import gsap from "gsap";

export default function bg() {
  const target = document.getElementById("site-bg");

  if (!target) return;

  gsap
    .timeline({
      scrollTrigger: {
        trigger: "body",
        start: "+=1200px",
        endTrigger: ".section-works",
        end: "40% center",
        scrub: true,
      },
    })
    .to(".site-bg__img_about", {
      opacity: 0,
      ease: "none",
    })
    .to(
      ".site-bg__img_works",
      {
        opacity: 1,
        ease: "none",
      },
      "<"
    );

  // switchBg(
  //   ".section-works",
  //   ".section-member",
  //   ".site-bg__img_works",
  //   ".site-bg__img_member"
  // );

  gsap
    .timeline({
      scrollTrigger: {
        trigger: ".section-works",
        start: "60% center",
        endTrigger: ".section-member .content",
        end: "top center",
        scrub: true,
      },
    })
    .to(".site-bg__img_works", {
      opacity: 0,
      ease: "none",
    })
    .to(
      ".site-bg__img_member",
      {
        opacity: 1,
        ease: "none",
      },
      "<"
    );

  // function switchBg(trigger, endTrigger, fadeOutEl, fadeInEl) {
  //   gsap
  //     .timeline({
  //       scrollTrigger: {
  //         trigger,
  //         start: "60% center",
  //         endTrigger,
  //         end: "40% center",
  //         scrub: true,
  //       },
  //     })
  //     .to(fadeOutEl, {
  //       opacity: 0,
  //       ease: "none",
  //     })
  //     .to(
  //       fadeInEl,
  //       {
  //         opacity: 1,
  //         ease: "none",
  //       },
  //       "<"
  //     );
  // }
}
